var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(!['Login', 'Register', 'Forget', 'WeavrWise'].includes(_vm.$route.name) && _vm.isWeavrwise)?_c('div',[(_vm.isOpen)?_c('div',{staticClass:"genai-sidebar-modal"},[_c('GenAiAsideBar',{attrs:{"isOpen":_vm.isOpen,"isDataSource":true}})],1):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }